@if (showBanner()) {
  <div class="production-warning-banner">
    <mat-icon>warning</mat-icon>
    <span>
      {{ 'navigation.production_warning.message' | translate: { tenant: tenantName() } }}
    </span>
  </div>
}
